export class MasterDataUpdatedEvent {
  constructor() {}
}
